import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink, RouterLinkActive } from '@angular/router';

import {
  CwButton,
  CwIcon,
  CwNavigationDrawer,
  CwNavigationDrawerGroup,
  CwNavigationDrawerItem,
  CwNavigationDrawerSection
} from '@bbraun/cortex-angular';
import { TranslocoDirective } from '@jsverse/transloco';

import { ROUTES } from '../../../definitions/constants/routes.constants';
import { processTablesNames } from '../../../definitions/enums/process-tables/process-tables-names.enum';
import { ProcessStatuses } from '../../../definitions/enums/replenishment-process/process-status';
import { ProcessType } from '../../../definitions/enums/replenishment-process/process-type.enum';
import { LayoutStoreFacade } from '../../../stores/global-store/layout/layout-store.facade';
import { UserConfigsStoreFacade } from '../../../stores/global-store/user-configs/user-configs-store.facade';
import { NavigationCountrySwitchComponent } from '../navigation-country-switch/navigation-country-switch.component';

@Component({
  selector: 'app-navigation-external',
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    TranslocoDirective,
    RouterLink,
    RouterLinkActive,
    NavigationCountrySwitchComponent,
    CwButton,
    CwIcon,
    CwNavigationDrawerSection,
    CwNavigationDrawer,
    CwNavigationDrawerItem,
    CwNavigationDrawerGroup
  ],
  templateUrl: './navigation-external.component.html',
  styleUrls: [ './navigation-external.component.sass' ],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class NavigationExternalComponent {
  protected readonly userConfigsFacade = inject(UserConfigsStoreFacade);
  protected readonly layoutFacade = inject(LayoutStoreFacade);

  protected readonly ProcessType = ProcessType;
  protected readonly processStatuses = ProcessStatuses;
  protected readonly processTablesNames = processTablesNames;

  protected readonly createProcessRoute = [ '/', ROUTES.REPLENISHMENT, ROUTES.CREATE_PROCESS ];
  protected readonly overviewRoute = [ '/', ROUTES.REPLENISHMENT, ROUTES.OVERVIEW ];
  protected readonly processesRoute = [ '/', ROUTES.REPLENISHMENT, ROUTES.PROCESSES ];
  protected readonly notificationsRoute = [ '/', ROUTES.REPLENISHMENT, ROUTES.NOTIFICATIONS ];
  protected readonly historyRoute = [ '/', ROUTES.REPLENISHMENT, ROUTES.HISTORY ];
  protected readonly analyticsRoute = [ '/', ROUTES.REPLENISHMENT, ROUTES.ANALYTICS ];
  protected readonly helpRoute = [ '/', ROUTES.REPLENISHMENT, ROUTES.HELP ];
}
